<div class="kt-widget24 widget-tile m-b-15" *ngIf="isModelLoaded">
    <div class="kt-widget24__details">
        <div class="kt-widget24__info">
            <h4 class="kt-widget24__title text-center fs-20">
                <a [routerLink]="['/work-order/grid-view', companyId]">Work Order</a>
            </h4>
        </div>
    </div>
    <div class="separator m-t-25 m-b-15">
    </div>
    <div class="kt-widget24__action">
        <span class="kt-widget24__change">
            Not Started <span class="m-l-10">{{totalWorkOrdersNotStarted}}</span>
        </span>
        <span class="kt-widget24__number">
            In Progress <span class="m-l-10">{{totalWorkOrdersInProgress}}</span>
        </span>
    </div>
</div>